var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-layout",attrs:{"id":"base-layout"}},[_c('div',{ref:"container",staticClass:"base-container"},[_vm._m(0),_c('section',{staticClass:"content"},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"header"},[_c('img',{attrs:{"src":require("@/assets/images/main/logo-grey.svg"),"alt":"logo"}})])
}]

export { render, staticRenderFns }